import { types } from "mobx-state-tree";

import { createCustomReadonlyDictionary } from "stores/templates/ReadonlyDictionaryStore";
import { MSURL } from "utils/ms";
import api from "services/api";

const pathQuiz = "/quiz/api/v1";
export const ResponseTypeDictionaryItem = types.model({
  id: types.string,
  title: types.string,
});

const ResponseTypeDictionary = createCustomReadonlyDictionary({
  itemModel: ResponseTypeDictionaryItem,
  fetch: async function() {
    const options = await api.get(
      `${pathQuiz}/free/list/response-type`,
      undefined,
      undefined,
      MSURL,
    );
    return {
      items: options.map((option: any) => ({
        id: option.code,
        title: option.title,
      })),
    };
  },
  getValue: value => value.id,
  getLabel: ({ title }) => title,
});

export default ResponseTypeDictionary.create();
